import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Image } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { availableApps } from '../../app/AppManager';
import { storage, TOKEN_INFO } from '../../app/Storage';
import { decode } from 'jsonwebtoken';

export class AppSelectMenu extends Component {
    static contextTypes = {
        selectedApp: PropTypes.object,
        selectApp: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            showApps: false
        };
    }

    appMenuClickHandler() {
        const { showApps } = this.state;

        this.setState({
            showApps: !showApps
        });
    }

    selectAppHandler(app) {
        this.context.selectApp(app, true);
        this.setState({
            showApps: false
        });
    }

    render() {
        if (0 === availableApps.length) {
            return (
                <div>&nbsp;</div>
            );
        }

        const { showApps } = this.state;

        let availableAppsCollection = [];
        let tokenInfo = storage.get(TOKEN_INFO);
        const selectedApp = undefined !== this.context.selectedApp ? this.context.selectedApp : availableApps[0];

        if (undefined !== tokenInfo) {
            var json = JSON.parse(tokenInfo);
            tokenInfo = Object.assign({}, json);
        }

        if (tokenInfo.id_token) {
            let idToken = decode(tokenInfo.id_token);

            if (idToken.apps) {
                availableAppsCollection = availableApps.filter(function (app) {
                    return idToken.apps.split(';').includes(app.path) && app.path !== selectedApp.path;
                });
            }
        }

        return (
            <div>
                <div className="icon-nav-item-app outline-none" tabIndex="0" onBlur={() => this.setState({ showApps: false })}>
                    <LinkContainer className="icon-nav-item-app-container" key={`app-item`} to="#">
                        <div>
                            <div className="icon-nav-item-app-icon" title={selectedApp.title}
                                onClick={() => this.appMenuClickHandler()} >
                                <Image responsive src={`icons/${selectedApp.path}.png`} />
                            </div>

                            <div className={showApps ? "icon-nav-item-available-apps-show" : "icon-nav-item-available-apps-hide"}>
                                {
                                    availableAppsCollection.map((appRow, i) =>
                                        <div key={i} className="icon-nav-item-available-app-icon"
                                            title={appRow.title}
                                            onClick={() => this.selectAppHandler(appRow.path)} >
                                            <Image responsive src={`icons/${appRow.path}.png`} />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </LinkContainer>
                </div>
            </div>
        );
    }
}
